import { render, staticRenderFns } from "./entityExtractionForm.vue?vue&type=template&id=0e6c2d02&scoped=true"
import script from "./entityExtractionForm.vue?vue&type=script&lang=js"
export * from "./entityExtractionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c2d02",
  null
  
)

export default component.exports